<template>
  <chart ref="chart" :options="chartOptions" />
</template>
<script>
import { Chart } from 'highcharts-vue'
import { map } from 'lodash'

export default {
  components: {
    Chart,
  },
  props: ['title', 'subtitle', 'data'],
  data() {
    return {
      loading: false,
      chartOptions: {
        chart: {
          height: 375,
        },
        title: {
          text: this.title,
        },
        subtitle: {
          text: this.subtitle,
        },
        plotOptions: {
          series: {
            turboThreshold: 0,
            marker: {
              radius: 0,
              states: {
                hover: {
                  radiusPlus: 4,
                },
              },
            },
          },
        },
        xAxis: {
          type: 'datetime',
        },
        yAxis: {
          title: {
            text: '€ bez dph/MWh',
          },
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          valueDecimals: 2,
          valueSuffix: ' € bez dph/MWh',
        },
        series: [],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadPDF'],
            },
          },
          filename: 'trhove-ceny-futures_' + this.title.toLowerCase(),
        },
      },
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler() {
        this.chartOptions.series = map(this.data, (item, key) => {
          return {
            name: key,
            data: item,
          }
        })
      },
      //this.chartOptions.series[0].data = this.data.values
    },
  },
  mounted() {},
}
</script>
